module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view users"
  }, [_c('box', {
    attrs: {
      "label": 'Brugere'
    }
  }, [_c('table', {
    staticClass: "table-a"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Fornavn")]), _vm._v(" "), _c('th', [_vm._v("Administrator?")])])]), _vm._v(" "), _vm._l((_vm.users), function(user, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.first_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user))])])
  })], 2), _vm._v(" "), _c('btn', [_vm._v("Opret ny bruger")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b70847b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Users.vue
// module id = 621
// module chunks = 1